import {
  // deliveryStatusOptions,
  receiveStatusOptions,
  collectionStatusOptions,
  invoiceStatusOptions,
} from '@/model/pickUpOrders';

const executionStatusGroup = [
  {
    label: '全部订单',
    value: '',
    en: 'allOrderNum',
    count: 0,
  },
  {
    label: '待发货',
    value: '1',
    en: 'receivingStsPendingNum',
    count: 0,
  },
  {
    label: '部分发货',
    value: '2',
    en: 'receivingStsPartNum',
    count: 0,
  },
  {
    label: '已发货',
    value: '3',
    en: 'receivingStsAllNum',
    count: 0,
  },
  {
    label: '无需发货',
    value: '4',
    en: 'receivingStsCanceledNum',
    count: 0,
  },
];

import * as Moment from 'dayjs';

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

export function setPickupOrdersTable () {
  const pickupOrdersTable = [
    {
      title: '订单编号',
      dataIndex: 'code',
      key: 'code',
      width: 160,
      ellipsis: true,
    },
    {
      title: '商品信息',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 300,
      ellipsis: true,
      customRender: (text, row) => {
        let goods = '';
        goods = row.orderGoodsList.map(item => `${item.goodsName}_${item.model}_${item.quantity}${item.unitName}`).join(' / ');
        return goods || '--';
      },
    },
    {
      title: '发货状态',
      dataIndex: 'deliveryStatus',
      key: 'deliveryStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(executionStatusGroup, text);
      },
    },
    {
      title: '物流填单',
      dataIndex: 'logisticsFillTypeDesc',
      key: 'logisticsFillTypeDesc',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '订单金额',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
      },
    },
    {
      title: '订单数量',
      dataIndex: 'totalQuantity',
      key: 'totalQuantity',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '收货信息',
      dataIndex: 'receiverDetailAddress',
      key: 'receiverDetailAddress',
      width: 220,
      ellipsis: true,
      customRender: (text, row) => {
        return `${row.receiverName || ''}-${row.receiverPhone || ''}-${row.receiverProvinceName || ''}${row.receiverCityName || ''}${row.receiverAreaName || ''}${row.receiverDetailAddress || ''}` || '--';
      },
    },
    {
      title: '收货状态',
      dataIndex: 'receiveStatus',
      key: 'receiveStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(receiveStatusOptions, text);
      },
    },
    {
      title: '客户抬头',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 200,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '订单来源',
      dataIndex: 'sourceTypeDesc',
      key: 'sourceTypeDesc',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '客户联系人',
      dataIndex: 'customerContactName',
      key: 'customerContactName',
      width: 180,
      ellipsis: true,
      customRender: (text, row) => {
        return text ? `${text || ''} ${row.customerContactPhone || ''}` : '--';
      },
    },
    {
      title: '销售合同号',
      dataIndex: 'outContractCode',
      key: 'outContractCode',
      width: 160,
      ellipsis: true,
      customRender: (text, row) => {
        return row.dockingSystem === 'XIAOZI_ERP' ? text || '--' : row.contractCode;
      },
    },
    {
      title: '订单状态',
      dataIndex: 'statusDesc',
      key: 'statusDesc',
      width: 120,
      ellipsis: true,
    },
    // {
    //   title: '开单时间',
    //   dataIndex: 'openOrderTime',
    //   key: 'openOrderTime',
    //   width: 180,
    //   ellipsis: true,
    //   customRender: (text) => {
    //     return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    //   },
    //   sorter: true,
    // },
    {
      title: '收款状态',
      dataIndex: 'collectionStatus',
      key: 'collectionStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(collectionStatusOptions, text);
      },
    },
    {
      title: '开票状态',
      dataIndex: 'invoiceStatus',
      key: 'invoiceStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(invoiceStatusOptions, text);
      },
    },
    {
      title: '结算方式',
      dataIndex: 'settleWayDesc',
      key: 'settleWayDesc',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '订单确认人',
      dataIndex: 'orderConfirmUserName',
      key: 'orderConfirmUserName',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '对方单据号',
      dataIndex: 'outOrderCode',
      key: 'outOrderCode',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      width: 180,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
  ];

  return pickupOrdersTable;
}
